<app-three-column-template
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="false">

  <app-side-navigation
    [customNavigation]="pageData()?.activeImportantDates"
    [pageData]="pageData()" slot="left-section"></app-side-navigation>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }


  <div class="important-date">
    <div class="part important-date-when">

      <div class="icon"><span class="icon-Clock"></span></div>
      <div class="content">
        <div class="title">{{ 'When'|translate }}:</div>
        <div class="desc">
          {{ HELPER.formatDateWithLocalizedMonth(pageData().startDate, true, true) }}
          - {{ HELPER.formatDateWithLocalizedMonth(pageData().endDate, true, true) }}
        </div>
      </div>

    </div>
    <div class="wrapper">

      <div class="part important-date-where">
        <div class="icon"><span class="icon-MapPin"></span></div>
        <div class="content">
          <div class="title">{{ 'Where'|translate }}:</div>
          <div class="desc">{{ pageData().location }}</div>
        </div>
      </div>

      <div class="part important-date-timezone">
        <div class="icon"><span class="icon-GlobeSimple"></span></div>
        <div class="content">
          <div class="title">{{ 'Timezone'|translate }}:</div>
          <div class="desc">{{ pageData().timezone }}</div>
        </div>
      </div>

      <div class="part important-date-calendar">
        <div class="icon"><span class="icon-Plus"></span></div>
        <div class="content">
          <div class="title">{{ 'Add to calendar'|translate }}:</div>
          <div (click)="createICal()" class="content add-to-calendar">iCal</div>
        </div>
      </div>

    </div>
  </div>

  <app-ck-viewer [fullBody]="true"
                 [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>

  <app-related-items [pageData]="pageData()"></app-related-items>

  <ng-container slot="right-section">

    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>
  </ng-container>


</app-three-column-template>
